'use client';

interface PhoneCallButtonProps {
  className: string;
  children: React.ReactNode;
}

export default function PhoneCallButton({ className, children }: PhoneCallButtonProps) {
  return (
    <a
      href="tel:0498545474"
      onClick={() => {
        if (typeof (window as any).gtag_report_conversion === 'function') {
          (window as any).gtag_report_conversion('tel:0498545474');
        }
      }}
      className={className}
    >
      {children}
    </a>
  );
}
